import type { HTMLAttributes } from "react";

import { clsx } from "../../utils/clsx";

interface ModalHeaderProps extends HTMLAttributes<HTMLDivElement> {}

export const ModalHeader = ({ className, ...rest }: ModalHeaderProps) => {
  return <div className={clsx("min-w-0 px-4 pt-16 pr-8 pb-8 [grid-area:header] sm:px-10", className)} {...rest} />;
};
